import React from "react";
import axios from "axios";
import cookie from 'react-cookies';
import {message} from 'antd';
import {Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";
import {displayError} from "../../../helper/display.error";

var querystring = require('querystring');

export const runDeepBioAI = (morphleId, slideId, selectedAnnotations, callback) => {
    let url = `/api/deep_bio_analysis_request/`
    axios.post(url,
    querystring.stringify({
        morphle_id: morphleId,
        slide_id: slideId,
        creator: parseInt(cookie.load('user_id')),
        checked_annotations: selectedAnnotations || [],
    })).then(res => {
        message.info("Request Successful")
        callback(res);
    }).catch(err => displayError("Request Failed, contact admin", err));
}

export const getDeepBioResultComponent = (summary, showTableHead) =>
    summary ? <TableContainer component={Paper}>
            <Table sx={{ width: '95%' }} size="small" aria-label="a dense table">
                {showTableHead ?
                    <TableHead>
                        <TableRow>
                            <TableCell>Property</TableCell>
                            <TableCell align="right">Value</TableCell>
                        </TableRow>
                    </TableHead> : undefined
                }
                <TableBody>
                    {Object.entries(summary).map(([key, value]) =>
                        <TableRow>
                            <TableCell sx={{color:"#00f548"}}>{key}</TableCell>
                            <TableCell>{value}</TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer> : null;
